<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("COMMON.TRANSFERS") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addTransfer()"
                v-if="$currentUserCan($permissions.PERM_CREATE_EQUIPMENT_TRANSFERS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("COMMON.ADD") }}
                </span>
              </base-button>

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_EQUIPMENT_TRANSFERS)"
                :objectType="'equipment-transfers'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <equipment-transfer-list-table
          :filterEstablishment="$route.query.establishment || null"
        />
      </card>
    </div>
  </div>
</template>

<script>
import EquipmentTransferListTable from "./partials/EquipmentTransferListTable.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import { Button } from "element-ui";

export default {
  name: "ListEquipmentTransferPage",
  components: {
    EquipmentTransferListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  methods: {
    addTransfer() {
      this.$router.push({ name: "Add EquipmentTransfer" });
    },
  },
};
</script>
